export enum SupportedLocaleEnum {
  fr = 'fr',
  en = 'en',
}
